export default __webpack_public_path__ + "static/ikgn-787448aa4b077b9e99cc798fa385044f.jpg";